import React from 'react';
import { useRoutes } from 'react-router-dom';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import router from 'src/router';

function App() {
  const content = useRoutes(router);

  const firebaseConfig = {
    apiKey: 'AIzaSyAKlkQVTixwu2PMXgGTVYbWq6be8yGrvtY',
    authDomain: 'sellpicinfo.firebaseapp.com',
    projectId: 'sellpicinfo',
    storageBucket: 'sellpicinfo.appspot.com',
    messagingSenderId: '712114412753',
    appId: '1:712114412753:web:d2d441ce012d11a7dd39f0',
    measurementId: 'G-LS7M599HBN'
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  getAnalytics(app);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        {content}
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;